import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/app.css'
import axios from 'axios'
import VeeValidate from "vee-validate";
import myconfig from './config'
import 'es6-promise/auto'
import Lang from 'lang.js'

var lang = new Lang()

window.axios = axios
if (process.env.NODE_ENV === 'production') {
  window.baseURL = myconfig.prd
} else {
  window.baseURL = myconfig.qa
}
window.lang = localStorage.getItem('lang')
Vue.config.productionTip = false
Vue.use(VeeValidate)

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js